import { inferStockStatus } from "~/utils/stock/infer-stock-status";

import { type BasketDiscount } from "../../types";

import { type KioskDisplayProductList } from "./types";

type GetIsAddDisabledArgs = {
  /** Units about to be added on top of what's already in the basket. */
  quantity?: number;
  stampCardDiscount?: BasketDiscount;
};

/**
 * Shared rule for disabling the add/increment action of a display product. A
 * `quantity` (e.g. a form quantity) can be layered on top of the product's
 * current stock/limit; pass `0` to check the product as-is.
 */
export function getIsAddDisabled(
  item: KioskDisplayProductList,
  { quantity = 0, stampCardDiscount }: GetIsAddDisabledArgs = {}
): boolean {
  const stockStatus = inferStockStatus({
    stock: item.product.stockStatus,
    quantity
  });

  const isLimitOver =
    item.product.remaining !== null
      ? item.product.remaining - quantity <= 0
      : item.product.isLimitOver;

  return (
    Boolean(stampCardDiscount) ||
    item.product.disabled ||
    stockStatus === "reserved" ||
    stockStatus === "out-of-stock" ||
    isLimitOver
  );
}
